window.$ = window.jQuery = require('jquery')
window.bootstrap = require('bootstrap')
window.AOS = require('aos')
require('owl.carousel')

export function templateURI(src) {
    return WPURLS.siteUrl + '/' + src
}

//
window.addEventListener('load', function () {
    AOS.init();
});

window.addEventListener('DOMContentLoaded', (event) => {

})
//
//
//
$(document).ready(function () {
    const widthHeader = $('#header').outerHeight();
    $('#banner-top-main').css({'height': `calc(100vh - ${widthHeader}px)`})
})

import './main'
import './modal'
import './mail'

